import type { Article, ArticleFaq } from "./articles";

const SITE_URL = import.meta.env.VITE_SITE_URL;
const SITE_NAME = "usfans Spreadsheet";
const LOGO_URL =
  "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/2277e9ffbdee9fd651886f1aeeba0d56.jpeg";

export const siteUrl = SITE_URL;
export const siteName = SITE_NAME;

export function websiteSchema(lang: string) {
  return {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebSite",
        "@id": `${SITE_URL}/#website`,
        url: `${SITE_URL}/`,
        name: SITE_NAME,
        inLanguage: lang,
      },
      {
        "@type": "Organization",
        "@id": `${SITE_URL}/#organization`,
        name: SITE_NAME,
        url: SITE_URL,
        logo: { "@type": "ImageObject", url: LOGO_URL },
      },
      {
        "@type": "WebPage",
        "@id": `${SITE_URL}/${lang}/#webpage`,
        url: `${SITE_URL}/${lang}/`,
        name: SITE_NAME,
        isPartOf: { "@id": `${SITE_URL}/#website` },
        inLanguage: lang,
        about: { "@id": `${SITE_URL}/#organization` },
      },
    ],
  };
}

export function articleSchema(article: Article, lang: string, image: string) {
  const url = `${SITE_URL}/${lang}/${article.slug}`;
  return {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: article.h1,
    description: article.metaDescription,
    image,
    inLanguage: lang,
    author: { "@type": "Organization", name: SITE_NAME, url: SITE_URL },
    publisher: {
      "@type": "Organization",
      name: SITE_NAME,
      logo: { "@type": "ImageObject", url: LOGO_URL },
    },
    datePublished: "2026-08-01",
    dateModified: "2026-08-20",
    mainEntityOfPage: { "@type": "WebPage", "@id": url },
  };
}

export function faqSchema(faq: ArticleFaq[]) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faq.map((item) => ({
      "@type": "Question",
      name: item.q,
      acceptedAnswer: { "@type": "Answer", text: item.a },
    })),
  };
}